import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';

import DeviceList from '../../components/DeviceList';
import PlaceList from '../../components/PlaceList';
import { useDevicePlaces, useDevices } from '../../services/queries';

import styles from './HomePage.module.scss';

const HomePage: React.FC = () => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<number | null>(null);

  const { data: devices = [], isLoading: loadingDevices, error: devicesError } = useDevices();

  const {
    data: places = [],
    isLoading: loadingPlaces,
    error: placesError,
  } = useDevicePlaces(selectedDeviceId);

  const handleDeviceSelect = (deviceId: number): void => {
    setSelectedDeviceId(deviceId);
  };

  const error = devicesError || placesError;

  useEffect(() => {
    if (error) {
      const errorMessage = error instanceof Error ? error.message : 'Произошла ошибка';
      toast.error(errorMessage);
    }
  }, [error]);

  return (
    <div className={styles.pageContainer}>
      {loadingDevices ? (
        <div className={classNames('text-center')}>
          <Spinner animation="border" role="status">
            <span className={classNames('visually-hidden')}>Загрузка...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <DeviceList
            devices={devices}
            selectedDeviceId={selectedDeviceId}
            onDeviceSelect={handleDeviceSelect}
          />

          {loadingPlaces ? (
            <div className={classNames('text-center', 'mt-4')}>
              <Spinner animation="border" role="status">
                <span className={classNames('visually-hidden')}>Загрузка мест...</span>
              </Spinner>
            </div>
          ) : (
            selectedDeviceId && <PlaceList deviceId={selectedDeviceId} places={places} />
          )}
        </>
      )}
    </div>
  );
};

export default HomePage;
